import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { getBackendFlowKey } from '../routing/getBackendFlowKey';
export const getExistingUserHubletChoice = () => {
  return noPortalApiClient.post('signup/v1/location/existing-user-available-hublets', {
    data: {
      flowKey: getBackendFlowKey()
    }
  });
};